import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useParams,
} from 'react-router-dom';
import { connect } from 'react-redux';

import IntroductionPage from './IntroductionPage';
import BinNumberPage from './BinNumberPage';
import IsMissingOrDamagedPage from './IsMissingOrDamagedPage';
import CartsListPage from './CartsListPage';
import Feedback from './Feedback';
import DamagedParts from './DamagedParts';

const DamagedCartPage = ({ damaged_cart_data }) => {
  const { path, url } = useRouteMatch();
  const { oidx } = useParams();
  const { push } = useHistory();
  const { extra_config } = damaged_cart_data.find(
    ({ oidx: index }) => index === Number(oidx)
  );

  useEffect(() => {
    const firstActiveScreen = extra_config.filter(
      (item) => item?.is_active === 'true'
    );
    push(`${url}/${firstActiveScreen[0].page.replace(/_/g, '-')}`);
  }, []);

  return (
    <div style={{ paddingTop: 60 }}>
      <Switch>
        <Route
          path={`${path}/introduction-page`}
          key={() => Math.random()}
          exact
          render={() => (
            <IntroductionPage
              url={url}
              data={extra_config.find(
                ({ page }) => page === 'introduction_page'
              )}
            />
          )}
        />
        <Route
          path={`${path}/carts-list-page`}
          key={() => Math.random()}
          exact
          render={() => (
            <CartsListPage
              url={url}
              data={extra_config.find(({ page }) => page === 'carts_list_page')}
            />
          )}
        />
        <Route
          path={`${path}/is-missing-or-damaged-page`}
          key={() => Math.random()}
          exact
          render={() => (
            <IsMissingOrDamagedPage
              url={url}
              data={extra_config.find(
                ({ page }) => page === 'is_missing_or_damaged_page'
              )}
            />
          )}
        />
        <Route
          path={`${path}/damaged-parts-page`}
          key={() => Math.random()}
          exact
          render={() => (
            <DamagedParts
              url={url}
              data={extra_config.find(
                ({ page }) => page === 'is_missing_or_damaged_page'
              )}
            />
          )}
        />
        <Route
          path={`${path}/bin-number-page`}
          key={() => Math.random()}
          exact
          render={() => (
            <BinNumberPage
              url={url}
              data={extra_config.find(({ page }) => page === 'bin_number_page')}
            />
          )}
        />
        <Route
          path={`${path}/feedback`}
          key={() => Math.random()}
          exact
          render={() => <Feedback url={url} />}
        />
      </Switch>
    </div>
  );
};

export default connect((store) => ({
  damaged_cart_data: store?.help?.helpItems.filter(
    ({ type }) => type === 'DAMAGED_CART'
  ),
}))(DamagedCartPage);
